import { useWorkbook } from '@/context/WorkbookContext';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';

export const TitlePage = () => {
  const { setCurrentPage, updateFormData, formData } = useWorkbook();
  
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-gradient-to-b from-secondary/30 to-background">
      <div className="max-w-2xl text-center">
        {/* Decorative top element */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="h-px w-12 bg-primary/30" />
          <div className="w-2 h-2 rounded-full bg-primary/50" />
          <div className="h-px w-12 bg-primary/30" />
        </div>
        
        {/* Main title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-foreground mb-6 leading-tight">
          The Rules of Money
        </h1>
        
        {/* Decorative element */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-r from-transparent to-primary/40" />
          <span className="text-primary text-xl">✦</span>
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-l from-transparent to-primary/40" />
        </div>
        
        {/* Subtitle */}
        <h2 className="text-lg sm:text-xl md:text-2xl font-serif text-muted-foreground mb-2 uppercase tracking-[0.15em]">
          Workbook
        </h2>
        
        <p className="text-base sm:text-lg text-foreground font-serif italic mb-12 max-w-md mx-auto">
          A Practical Guide for Real Life, Real Income, and Real Growth
        </p>
        
        {/* User name input */}
        <div className="mb-10 max-w-sm mx-auto">
          <label className="block text-sm text-muted-foreground mb-2 text-left">
            This workbook belongs to:
          </label>
          <input
            type="text"
            className="w-full border-b-2 border-primary/30 bg-transparent py-3 px-2 text-center text-lg focus:outline-none focus:border-primary transition-colors"
            placeholder="Your name"
            value={formData.userName || ''}
            onChange={(e) => updateFormData('userName', e.target.value)}
          />
        </div>
        
        {/* Start date */}
        <p className="text-sm text-muted-foreground mb-12">
          Started: {new Date(formData.startDate || new Date()).toLocaleDateString('en-US', { 
            month: 'long', 
            day: 'numeric', 
            year: 'numeric' 
          })}
        </p>
        
        {/* Begin button */}
        <Button 
          onClick={() => setCurrentPage('copyright')}
          size="lg"
          className="gap-2 px-10"
        >
          Begin Your Journey
          <ChevronRight className="h-4 w-4" />
        </Button>
        
        {/* Footer note */}
        <p className="mt-16 text-xs text-muted-foreground/60 max-w-md mx-auto">
          Written so a 7th grader can read and follow. Clear, calm, encouraging—no shame, no hype.
        </p>
      </div>
    </div>
  );
};
